/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportUserRewardContextRequest
 */
export interface SupportUserRewardContextRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportUserRewardContextRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the SupportUserRewardContextRequest interface.
 */
export function instanceOfSupportUserRewardContextRequest(value: object): value is SupportUserRewardContextRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function SupportUserRewardContextRequestFromJSON(json: any): SupportUserRewardContextRequest {
    return SupportUserRewardContextRequestFromJSONTyped(json, false);
}

export function SupportUserRewardContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportUserRewardContextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function SupportUserRewardContextRequestToJSON(json: any): SupportUserRewardContextRequest {
    return SupportUserRewardContextRequestToJSONTyped(json, false);
}

export function SupportUserRewardContextRequestToJSONTyped(value?: SupportUserRewardContextRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

